/* eslint-disable no-unused-vars */
import React from 'react';
import _ from 'lodash';
import fetchMg from '../utilities/fetchManager';
import ScrollListItem from './ScrollListItem';
import { WorkScheduleService } from '../services/Works';
import ReloadHelper from '../services/utilities/ReloadHelper';

export default class WorkScrollGroup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show_lists: this.props.isOpened || true, // すべてのリストの開閉フラグ
    };

    this.handleToggleOpenGroup = this.handleToggleOpenGroup.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpened !== this.props.isOpened) {
      this.setState({ show_lists: this.props.isOpened });
    }
  }

  handleToggleOpenGroup = isOpened => () => {
    this.setState({ show_lists: isOpened });
  };

  /**
   * @description 追加ロードして this.props.workGroupData.works を更新する。
   */
  async AddItemLoad() {
    const { items, totalCount } = await this.props.loadWorksUnit({
      fieldId: this.props.workGroupData.field_id,
      workGroupId: this.props.workGroupData.id,
      searchParams: this.props.searchParams,
      offset: this.props.workGroupData.works.length,
    });

    const works = this.props.workGroupData.works.concat(items);
    this.props.onUpdateWorksInGroup({
      workGroupId: this.props.workGroupData.id,
      works,
      worksLoadComp:
        works.length === totalCount
          ? true
          : this.props.workGroupData.worksLoadComp,
    });
  }

  setScrollItems() {
    // console.log('ScrollGroup.jsx', 'setScrollItems');
    const { workGroupData, isDisplayReflectTotalColumn } = this.props;

    const items = _.map(workGroupData.works, (work, i) => {
      if (i === 0) {
        return (
          <ScrollListItem
            data={work}
            key={`test-item-${work.id}-${i}`}
            isGroupTop={true}
            showLists={this.handleToggleOpenGroup}
            show_lists={this.state.show_lists}
            scheduleFlag={this.props.scheduleFlag}
            unapprovedFlag={this.props.unapprovedFlag}
            index={i}
            groupManHours={workGroupData.totalSumHours} // 人工の小計
            selected={this.props.selected}
            work_group_id={workGroupData.id}
            checked={this.props.selectedList.includes(work.id)}
            groupSelected={this.props.group_selected}
            onWorkSelect={() => {
              this.props.onWorkSelect(work.id);
            }}
            onGroupSelect={isSelected => {
              this.props.onGroupSelect(
                this.props.groupId,
                this.props.privatePartnerCompanyFlag,
                isSelected
              );
            }}
            onApprovalStatusClick={this.props.onApprovalStatusClick}
            onManHourEditClick={() => this.props.onManHourEditClick(work.id)}
            usePartnerCompanyApprovalFlag={
              this.props.usePartnerCompanyApprovalFlag
            }
            partnerApprovalName={this.props.partnerApprovalName}
            onPartnerApprovalSinglePreparation={
              this.props.onPartnerApprovalSinglePreparation
            }
            workColumnsSettings={this.props.workColumnsSettings}
            isShowReflectedWorkTotal={workGroupData.isShowReflectedWorkTotal}
            reflectedWorkTotal={workGroupData.reflected_work_total}
            isDisplayReflectTotalColumn={isDisplayReflectTotalColumn}
          />
        );
      } else if (this.state.show_lists) {
        return (
          <ScrollListItem
            data={work}
            key={`test-item-${work.id}`}
            isGroupTop={false}
            show_lists={this.state.show_lists}
            index={i}
            scheduleFlag={this.props.scheduleFlag}
            unapprovedFlag={this.props.unapprovedFlag}
            selected={this.props.selected}
            checked={this.props.selectedList.includes(work.id)}
            groupSelected={this.props.group_selected}
            onGroupSelect={isSelected => {
              this.props.onGroupSelect(
                this.props.groupId,
                this.props.privatePartnerCompanyFlag,
                isSelected
              );
            }}
            onWorkSelect={() => {
              this.props.onWorkSelect(work.id);
            }}
            onApprovalStatusClick={this.props.onApprovalStatusClick}
            onManHourEditClick={() => this.props.onManHourEditClick(work.id)}
            usePartnerCompanyApprovalFlag={
              this.props.usePartnerCompanyApprovalFlag
            }
            partnerApprovalName={this.props.partnerApprovalName}
            onPartnerApprovalSinglePreparation={
              this.props.onPartnerApprovalSinglePreparation
            }
            workColumnsSettings={this.props.workColumnsSettings}
            isShowReflectedWorkTotal={false}
            isDisplayReflectTotalColumn={isDisplayReflectTotalColumn}
          />
        );
      } else {
        return null;
      }
    });

    // ロードボタンを追加
    if (
      _.isArray(this.props.workGroupData.works) &&
      this.props.workGroupData.works.length !== 0 &&
      this.state.show_lists &&
      this.props.workGroupData.worksLoadComp === false
    ) {
      items.push(
        <tr key='add-load-button' className='see-more'>
          <td colSpan='15'>
            <button
              className='see-more__button see-more__button__blue'
              onClick={this.AddItemLoad.bind(this)}
            >
              <i className='see-more__button__icon' />
              <p className='see-more__button__text'>さらに表示する</p>
            </button>
          </td>
        </tr>
      );
    }

    return items;
  }

  render() {
    return (
      <tbody
        className={
          this.state.show_lists ? 'data-table__group show' : 'data-table__group'
        }
        style={{
          overflow: 'scroll',
        }}
      >
        {this.setScrollItems()}
      </tbody>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ScrollGroup.jsx